<template>
    <v-layout row justify-center>
        <v-dialog v-model="modalfollowers" persistent scrollable max-width="360px">
            <v-card>
                <div style="margin-top:20px;text-align:center">
                    <label style="font-size:30px; font-weight:bold">{{language==='English'?'Followers':'Seguidores'}}</label>
                </div>
                <v-divider></v-divider>
                <!--v-layout justify-center>
                    <v-flex xs11>
                        <v-text-field
                                v-model="inputsearchlaundries"
                                outline
                                label="Buscar"
                                append-icon="search"
                                @keyup="searchingfavoriteslaundries"
                        ></v-text-field>
                    </v-flex>
                </v-layout-->
                <v-card-text style="height: 300px;">
                    <div v-if="followers.length<=0">
                        <label>{{language==='English'?'there are no followers':'No hay seguidores'}}</label>
                    </div>
                    <!--card-product-->
                    <div class="overflow:scroll">
                        <div class="card-favorites" v-for="(item) in followers" :key="item.length">
                            <img style="border-radius:100%; padding:10px; cursor:pointer" :src="item._id_user.photo[0].link">
                                <!--Product name-->
                            <div class="card-favorites-infos"  style="cursor:pointer" @click="goprofileuser(item._id_user.username)">
                                <p style="font-size:14px">{{item._id_user.fullname}}</p>
                            </div>
                            <div v-if="ismyprofile" class="card-favorites-infos" style="margin-left:9px">
                                <label class="fas fa-trash" style="cursor:pointer" @click="deleteuserfollower(item._id_user._id)"></label>
                            </div>
                        </div>
                        <infinite-loading @infinite="infiniteHandler"/>
                    </div>
                </v-card-text>
                <div class="text-center">
                    <v-btn color="primary" @click="modalfollowers = false">{{language==='English'?'Close':'Cerrar'}}</v-btn>
                </div>
            </v-card>
        </v-dialog>
  </v-layout>
</template>
<script>
import {EventBus} from '@/helpers/eventbus/event-bus'
import InfiniteLoading from 'vue-infinite-loading'
import env from '../../../config/env.example'
import {UsersService} from "@/services"


export default {
    data(){
        return{
            language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
            modalfollowers: false,
            followers:[],
            page:0,
        }
    },
    components: {
        'infinite-loading':InfiniteLoading
    },
    props:{
        iduser:'',
        ismyprofile:false
    },
    mounted(){
        this.infiniteHandler()
        EventBus.$on('openmodalfollowers',()=>{
            this.modalfollowers = true
        })
        EventBus.$on('getsignalfollowerdeleted',(datauser)=>{
            this.followers =  this.followers.filter(followers =>String(followers._id_user._id) !== String(datauser.id))
        })
        EventBus.$on('newfollower',(newfollower)=>{
            if(newfollower){
                this.followers =  this.followers.concat(newfollower)
            }
        })
    },
    methods:{
        goprofileuser(username){
            window.location = `${env.host}${username}`
        },
        deleteuserfollower(iduserfollower){
			let data = {
				_id_user:this.iduser,
				id: iduserfollower
            }
            UsersService.stopfollowingthisuser(data).then(res=>{
				let datasend = {
					iduser: this.iduser,
					id: iduserfollower
				}
				this.$socket.emit('signaldeletefollower',datasend)
			})
			
		},
        infiniteHandler: function ($state) {
                let limit = this.followers.length / 40 + 1;
                let data = {
                _id_user:this.iduser,
                page: limit
            }
            UsersService.getfollowers(data).then(res=>{
				this.loadMore($state, res)
			})
        },
			loadMore: function ($state, response) {
                if(!response.data.followers.length <=0){
                    if ( response.data.followers.length ) {
                        this.followers = this.followers.concat(response.data.followers)
                        setTimeout(() => {
                            $state.loaded()
                        }, 3000);
                        /*
                        if ( response.followers.length == this.followers.length ) {
                            $state.complete();
                        }*/
                    } else {
                        $state.complete()
                    }
                }else{
                    $state.complete()
                }
            },
            
        /*
        infiniteHandler($state){
            this.page++
            let data = {
                _id_user:this.iduser,
                page: this.page
            }
            this.axios.post('users/getfollowers',data)
            .then(res=>{
                let followers = res.data.followers
                console.log(followers)
                if(followers.length){
                    this.followers = this.followers.concat(followers)
                    $state.loaded()
                }else{
                    $state.complete()
                }
            })
        }*/
    }
}
</script>
<style lang="scss" scoped>
    /*favorites name*/
    .card-favorites {
        overflow: hidden;
        height: 120px;
        background: white;
        box-shadow: 0 0 15px rgba(0,0,0,0.2);
        display: flex;
        align-items: center;
        margin-top: 20px
    }

    .card-favorites img {
        height: 80%;
        width: 100px;
        object-fit: cover;
    }

    .card-favorites h2 {
        font-size: 16px;
        font-weight: bold;
        margin: 0;
    }

    .card-favorites p {
        font-size: 12px;
        line-height: 1.4;
        opacity: .7;
        margin-bottom: 0;
        margin-top: 8px;
    }

    
</style>
